import { CommonModule, isPlatformBrowser } from '@angular/common';
import { Component, inject, OnDestroy, OnInit, PLATFORM_ID } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SharedModule } from 'primeng/api';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ToastModule } from 'primeng/toast';

import { HealthService, ResellerService, VersionCheckerService } from '@shared/services';

import { LayoutService } from './_layout/services/app-layout.service';

@Component({
  selector: 'app-root',
  imports: [RouterModule, ToastModule, SharedModule, ConfirmDialogModule, CommonModule],
  template: `
    <p-confirmDialog />
    <p-toast />
    <router-outlet />
  `,
})
export class AppComponent implements OnInit, OnDestroy {
  platformId = inject(PLATFORM_ID);

  constructor(
    private versionCheckerService: VersionCheckerService,
    private layoutService: LayoutService,
    private resellerService: ResellerService,
    private healthService: HealthService
  ) {
    this.versionCheckerService.checkForUpdate();
  }

  ngOnInit() {
    if (isPlatformBrowser(this.platformId)) {
      this.layoutService.initPreset();
      this.resellerService.storeInitialReseller();
    }

    this.healthService.startHealthCheckPolling();
  }

  ngOnDestroy(): void {
    this.healthService.stopHealthCheckPolling();
  }
}
